import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import CustomersRequested from '../events/CustomersRequested';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import CustomersReceived from '../events/CustomersReceived';
import RequestFailed from '../../core/events/RequestFailed';
import State from '../../core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(CustomersRequested.type),
        mergeMap(() =>
            backend.get(`${api()}customers`).pipe(
                map((ajaxResponse: AjaxResponse) => new CustomersReceived(ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            )
        )
    );



// WEBPACK FOOTER //
// ./src/application/admin/epic/customersGet.ts